module.exports = __webpack_public_path__ + "static/media/B5.e37568b2.png";